import React from "react";

function ConnectButton() {
  return <w3m-button />;
}

export default ConnectButton;
